import yup from '../../../config/yup';

export const httpV2ReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('httpV2Reader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    paginationType: yup.string().oneOf(['QueryString', 'RequestBody', 'Stream']),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    acceptInvalidCerts: yup.boolean(),
    url: yup.string(),
    headers: yup.string(),
    body: yup.string(),
    queryString: yup.string(),
  }),
});
